import {GearIcon} from '@primer/octicons-react'
import {Box, Text, Heading, type SxProp, Button} from '@primer/react'

export type StyledHeadingProps = {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
} & SxProp

export type SectionHeaderProps = {
  title: string
  buttonProps?: React.HTMLAttributes<HTMLButtonElement>
  headingProps?: StyledHeadingProps
  readonly?: boolean
} & SxProp

export function SectionHeader({
  title,
  buttonProps,
  headingProps: {as: Component = 'h3', ...headingProps} = {},
  readonly,
  ...props
}: SectionHeaderProps) {
  const containerProps = readonly
    ? {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        pb: '8px',
        ...props.sx,
      }
    : {
        width: '100%',
        position: 'relative',
        ...props.sx,
      }

  return (
    <Box sx={containerProps}>
      <Heading
        as={Component}
        sx={{
          top: 1,
          left: 2,
          fontSize: 0,
          color: 'fg.muted',
          position: readonly ? 'relative' : 'absolute',
          pointerEvents: 'none',
          ...headingProps,
        }}
      >
        {title}
      </Heading>
      {!readonly && (
        <Button
          {...buttonProps}
          variant="invisible"
          size="small"
          trailingAction={GearIcon}
          block
          sx={{alignContent: 'start'}}
        >
          <Text className="sr-only" sx={{fontWeight: 600, fontSize: 0, lineHeight: '20px', color: 'fg.muted'}}>
            {`Edit ${title}`}
          </Text>
        </Button>
      )}
    </Box>
  )
}

try{ SectionHeader.displayName ||= 'SectionHeader' } catch {}